import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../../stores/NavigateStore";

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        minHeight: 'calc(100vh - 54px)',
        marginTop: 54,
        padding: 24,
        boxSizing: 'border-box'
    },
    emptyBox: {
        width: '100%',
        height: `calc(100vh - ${topHeight}px - 36px - 20px - 24px - 24px)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& p': {
            fontSize: '1.375rem',
            color: '#87888d',
            fontWeight: 400,
            textAlign: 'center',
            lineHeight: '30.36px'
        }
    },
    tableBox: {
        borderRadius: '8px 8px 0 0',
        boxShadow: 'none',
        background: '#fff',
        '&::-webkit-scrollbar': {
            width: '10px',
            height: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#6f6f6f',
            borderRadius: '10px',
            backgroundClip: 'padding-box',
            border: '3px solid transparent',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
            marginTop: 5,
        },
    },
    table: {
        minWidth: 930,
    },
    tableHeadStyle: {
        '& th': {
            height: 50,
            padding: '0 10px',
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        }
    },
    tableBodyStyle: {
        '& th, td': {
            padding: '13px 10px',
            fontSize: '1rem',
            fontWeight: 400,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        },
        '& th': {
            fontWeight: 700,
        },
    },
    tableButton: {
        width: 80,
        height: 30,
        borderRadius: 4,
        background: '#5579F0',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 700,
        '&:hover': {
            background: '#5579F0'
        }
    },
    tableButton2: {
        width: 120,
        height: 30,
        borderRadius: 4,
        background: '#5579F0',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 700,
        '&:hover': {
            background: '#5579F0'
        }
    },
    sortButton: {
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        '& p': {
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            marginRight: 4,
            marginLeft: 10,
        }
    },
    paginationBox: {
        '& .MuiToolbar-root': {
            position: 'relative',
        },
        '& .MuiInputBase-root': {
            marginLeft: 0,
            marginRight: 20
        },
        '& .MuiSelect-select': {
            fontSize: '0.75rem',
            color: '#323232',
            paddingRight: 17,
            '&:focus': {
                background: 'transparent'
            }
        },
        '& .MuiTablePagination-caption': {
            fontSize: '0.75rem',
            color: '#10121c',
            fontWeight: 400
        },
        '& .MuiTablePagination-selectLabel': {
            fontSize: '0.75rem',
            color: '#323232',
        },
        '& .MuiTablePagination-selectRoot': {
            '& svg': {
                marginTop: 3
            }
        },
        '& button': {
            padding: 0,
            '&:hover': {
                background: 'transparent'
            },
        }
    },
    displayRow: {
        '& span': {
            fontWeight: '700 !important'
        }
    },
    selectPopover: {
        '& .MuiPaper-root': {
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing: 'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '0.875rem',
            color: '#323232',
            padding: '0 12px',
            boxSizing: 'border-box',
            height: 28,
            '&:hover': {
                background: '#eee'
            },
            '&.Mui-selected': {
                background: '#eee'
            },
            '&.Mui-disabled': {
                opacity: 1,
                '& svg': {
                    pointerEvents: 'auto'
                }
            },
        }
    },
    activeStepIcon: {
        width: '100%',
        padding: 0,
        marginTop: 5,
        '& .MuiStepIcon-active': {
            color: '#5579f0',
        },
        '& .MuiStepIcon-completed': {
            border: '1px solid #5579f0',
            borderRadius: '100%',
            color: '#fff'
        },
    },

    textBox: {
        width:'100%',
        '& .MuiBox-root': {
            padding: '10px 0px',
            width:'100%'
        },
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 150,
            }
        }
    },
    textBoxTranslation: {
        '& .MuiFormControl-root': {
            width: '100%',

            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 110,
            }
        }
    },
    topBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        background: '#fff',
        borderRadius: 8,
        height: 170,
        marginBottom: 20,
        paddingTop: 35,
        '& .Mui-disabled': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #e5e5e5',
                color: '#e5e5e5',
                background: '#fff',
            }
        },
        '& .MuiStepIcon-root': {
            width: 40,
            height: 40,
        },
        '& .MuiStepConnector-alternativeLabel': {
            top: 20,
            left: 'calc(-50% + 30px)',
            right: 'calc(50% + 30px)',
        },
        '& .MuiStepLabel-iconContainer': {
            border: '1px solid #5579f0',
            width: 40,
            height: 40,
            borderRadius: '100%',
            color: '#fff',
            background: '#5579f0',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            textAlign: 'center',
            display: 'inline-block',
            lineHeight: '38px',
        },
        '& .MuiStep-completed': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #5579f0',
                color: '#5579f0',
                background: '#fff',
            }
        },
        '& .MuiStepConnector-active': {
            '& .MuiStepLabel-iconContainer': {
                border: '1px solid #fff',
            }
        },
        '& .MuiStepLabel-label': {
            fontSize: '1.125rem',
            letterSpacing: '-0.5px',
            color: '#87888d',
            marginTop: 9,
            wordBreak: 'break-word',
        },
        '& .MuiStepLabel-label.MuiStepLabel-completed': {
            color: '#10121c',
        },
        '& .MuiStepLabel-label.MuiStepLabel-active': {
            color: '#5579f0'
        },
    },
    setBtn: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    buttonStyle: {
        '&.MuiButtonBase-root': {
            width: 180,
            height: 36,
            padding: 0,
            minHeight: 36,
            background: '#5579F0',
            borderRadius: 4,
            marginLeft: 10,
            boxSizing: 'border-box',
            '&:hover': {
                background: '#5579F0',
            },
            '& p': {
                fontSize: '0.875rem',
                color: '#fff',
                fontWeight: 700,
                marginLeft: 8
            },
            '&.Mui-disabled': {
                background: 'rgba(16, 18, 28, 0.30)',
                '& p': {
                    color: 'rgba(255, 255, 255, 0.70)'
                },
                '& path': {
                    stroke: 'rgba(255, 255, 255, 0.70)'
                }
            }
        }
    },
    buttonStyle3: {
        '&.MuiButtonBase-root': {
            width: 70,
            background: '#10121C',
            marginLeft: 16,
            '& p': {
                marginLeft: 0
            },
            '&:hover': {
                background: '#10121C',
            },
        }
    },
    formControlAccount: {
        '&.MuiFormControl-root ': {
            margin: 0,
        },
        '& .MuiSelect-select': {
            width: 240,
            height: 40,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing: 'border-box',
            color: '#777',
            letterSpacing: '-0.5px',
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px rgba(50, 50, 50, 0.8)',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select': {
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    formControl: {
        '&.MuiFormControl-root ': {
            margin: 0,
        },
        '& .MuiSelect-select': {
            width: 130,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing: 'border-box',
            color: '#777',
            letterSpacing: '-0.5px',
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px rgba(50, 50, 50, 0.8)',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select': {
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },

    formControl2: {
        '& .MuiSelect-select': {
            marginLeft: 15,
            width: 240,
        },
    },
    textQuizBox: {
        marginLeft: 15,
        '& .MuiFormControl-root': {
            width: 240,
            height: 36,
            boxSizing: 'border-box',
            background: '#fff',
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 10px',
        }
    },
    submitBox: {
        margin: '0px 0px 20px 0px'
    },
    iconButton: {
        '&.MuiIconButton-root': {
            width: 'auto',
            marginLeft: 15,
        },
        padding: '9px 14px',
        '&:hover': {
            background: 'transparent'
        }
    },
    popoverTooltip: {
        '& .MuiPopover-paper': {
            background: '#365edf',
            color: '#fff',
            minWidth: 270,
            minHeight: 90,
            padding: '10px 10px 10px 15px',
            overflow: 'visible',
            marginTop: 15,
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '15px',
            lineHeight: '21px',
            letterSpacing: '-0.5px',
        }
    },
    popoverTooltipBottom: {
        '& .MuiPopover-paper': {
            background: '#365edf',
            color: '#fff',
            minWidth: 400,
            minHeight: 66,
            padding: '10px 10px 10px 15px',
            overflow: 'visible',
            marginTop: 0,
        },
        '& .MuiTypography-root': {
            color: '#fff',
            fontSize: '15px',
            lineHeight: '21px',
            letterSpacing: '-0.5px',
        }
    },
    tooltipTop: {
        position: 'absolute',
        top: -10,
        left: '50%',
        color: '#000'
    },
    tooltipBottom: {
        position: 'absolute',
        bottom: -15,
        left: '50%',
        color: '#000',
        '& svg': {
            transform: 'rotate(180deg)',
        }
    },
    tooltipBtn: {
        '& .MuiButtonBase-root': {
            padding: 0,
            minWidth: 'auto',
            '&:hover': {
                background: 'transparent'
            }
        }
    },
    titleDialog: {
        '& .MuiTypography-root': {
            fontSize: '1.563rem',
            fontWeight: 500,

        }
    },
    resetPassword: {
        '&.MuiButtonBase-root': {
            border: '1px solid #0097FF',
            borderRadius: 7,
            width: 92,
            height: 40,
            '&:hover': {
                background: '#fff'
            },
            '& .MuiTypography-root': {
                fontSize: '0.813rem',
                fontWeight: 'bold',
                color: '#0097FF',

            }
        }
    },

    myPageBox: {
        '& .MuiBox-root': {
            marginBottom: 20,
        },
        '& .MuiBox-root:last-child': {
            marginBottom: 0,
        },
        // width: 830,
        // height: 700,
        background: '#fff',
        borderRadius: 10,
        padding: 30,
        '& > .MuiTypography-root': {
            textAlign: 'center',
            fontSize: '1.688rem',
            margin: '50px 0px 30px',

        }
    },
    myPageTitle: {
        width: 130,
        '&.MuiTypography-root': {
            fontSize: '1.25rem',
            fontWeight: 700,
            '& span': {
                color: '#FF0000',
                fontWeight: 'bold'
            }
        }
    },
    emailTitle: {
        width: 220,
        '&.MuiTypography-root': {
            fontSize: '1.25rem',
            fontWeight: 700,
        }
    },
    emailNotice: {
        marginTop: 10,
        '&.MuiTypography-root': {
            fontSize: '1.125rem',
            color: '#FF0000'
        }
    },
    myPageText: {
        width: 300,
        '&.MuiTypography-root': {
            fontSize: '1.375rem',
        }
    },
    passwordBtn: {
        '&.MuiButtonBase-root': {
            minWidth: 40,
            width: 40,
            padding: 0,
            '&:hover': {
                background: 'transparent',
            }
        },
        '& .MuiTypography-root': {
            color: '#0097FF',
            textDecoration: 'underline',
            fontSize: '1.375rem',
        }
    },
    emailContent: {
        '& .MuiBox-root': {
            marginBottom: 0,
        },
    },
    emailBox: {
        '&.MuiBox-root': {
            marginBottom: 0,
        },
        '& .MuiFormControl-root': {
            width: 240,
            height: 36,
            boxSizing: 'border-box',
            background: '#fff',
            marginRight: 10,
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        }
    },
    emailTwoBox: {
        '&.MuiBox-root': {
            marginBottom: 0,
        },
        '& .MuiFormControl-root': {
            width: 102,
            height: 36,
            boxSizing: 'border-box',
            background: '#fff',
            marginRight: 10,
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        '& > span': {
            marginRight: 7,
            fontSize: '1.125rem'
        }
    },
    groupBtn: {
        margin: '0 auto 40px'
    },
    inputButton: {
        '&.MuiButtonBase-root': {
            width: 440,
            background: '#d4d4d4',
            height: 48,
            '&:hover': {
                background: '#d4d4d4',
            }
        },
        '& .MuiTypography-root': {
            fontSize: '1.125rem',
            color: '#fff',
            fontWeight: 'bold',
        }
    },
    inputButtonActive: {
        '&.MuiButtonBase-root': {
            background: '#7445FF',
            '&:hover': {
                background: '#7445FF',
            }
        },
    },
    accountBtn: {
        marginRight: 10,
        '&.MuiButtonBase-root': {
            background: '#0097FF',
            borderRadius: 7,
            width: 92,
            height: 40,
            '&:hover': {
                background: '#0097FF',
            }
        },
        '& .MuiTypography-root': {
            fontSize: '0.813rem',
            color: '#fff',
            fontWeight: 'bold',
        }
    },
    accountBtn2: {
        '&.MuiButtonBase-root': {
            border: '1px solid #0097FF',
            borderRadius: 7,
            width: 92,
            height: 40,
            '&:hover': {
                background: '#fff'
            },
            '& .MuiTypography-root': {
                fontSize: '0.813rem',
                fontWeight: 'bold',
                color: '#0097FF',

            }
        }
    },
    disabledBtn: {
        '&.MuiButtonBase-root': {
            border: '1px solid #d3d3d3',
            borderRadius: 7,
            width: 92,
            height: 40,
            '&:hover': {
                background: '#fff'
            },
            '& .MuiTypography-root': {
                fontSize: '0.813rem',
                fontWeight: 'bold',
                color: '#d3d3d3',

            }
        }
    },
    typeAccount: {
        '& .MuiRadio-colorSecondary.Mui-checked': {
            color: '#1554F6'
        }
    },
    btnType1: {
        '&.MuiButtonBase-root': {
            width: 200,
            height: 47,
            border: '1px solid #605BFF',
            borderRadius: 8,
            marginRight: 10,
            '&:hover': {
                background: '#fff',
            },
            '& .MuiTypography-root': {
                fontWeight: 'bold',
                color: '#605BFF'
            }
        }
    },
    btnType2: {
        '&.MuiButtonBase-root': {
            width: 200,
            height: 47,
            background: '#605BFF',
            borderRadius: 8,
            '&:hover': {
                background: '#605BFF',
            },
            '& .MuiTypography-root': {
                fontWeight: 'bold',
                color: '#fff'
            }
        }
    },
    btnNotice: {
        '&.MuiTypography-root': {
            color: '#FF0000',
            fontSize: '1rem'
        }
    },
    noticeText: {
        marginLeft: 65,
        '& .MuiTypography-root': {
            fontSize: '0.875rem',
            textAlign: 'left',
            color: '#FF0000',
            marginLeft: 5,
        },
    },
    chart: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    },
    toggleButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    tabBox: {
        width:'100%',
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 100,
        },
        '& .MuiTabs-flexContainer': {
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden',
        },
        '& button': {
            width: 70,
            minHeight: 40,
            height: 40,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#000',
            opacity: 1,
            boxSizing: 'border-box',
            background: 'transparent',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#000'
        }
    },
    boxWrap: {
        backgroundColor: '#fff',
        // padding: 20,
        borderRadius: 8,
    },
    boxBottomTranslation: {
        backgroundColor: '#fff',
        padding: 20,
        borderRadius: 8,
        marginTop: 20,
        // height: 'calc(100vh - 605px)',
        overflowX: 'auto',
        '& .MuiFormControl-root': {
            width: '100%',
            '& .MuiInputBase-root': {
                height: 110,
            },
        },
        '& div:nth-child(1)': {
            marginTop: 0,
        }
    },
    translationTitle: {
        marginTop: 33,
        marginBottom: 10,
        '& .MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
        },
        '& .MuiButtonBase-root': {
            minWidth: 'auto',
            padding: 0,
            '&:hover': {
                background: 'transparent'
            },
        }
    },
    langText: {
        '&.MuiTypography-root': {
            fontSize: '0.938rem',
            fontWeight: 'bold',
            letterSpacing: '-0.5px',
            color: '#10121c',
            marginRight: 10,
        },
    },
    swichStyle: {
        '&.MuiSwitch-root': {
            padding: '10px 10px',
        },
        '& .MuiSwitch-switchBase': {
            color: '#fff',
        },
        '& .MuiSwitch-thumb': {
            width: 14,
            height: 14,
        },
        '& .MuiButtonBase-root': {
            paddingTop: '12px',
            paddingLeft: '12px',
        },
        '& .MuiSwitch-track': {
            borderRadius: 10,
        },
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            background: '#5579f0',
            opacity: 1
        }
    },
    translateButtonArea:  {
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    saveButtonArea: {
        marginTop:10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-between'
    },
    headerArea : {
        '& .MuiBox-root': {
            padding: '30px 24px 0px 24px',
        },
        '& .MuiFormControl-root': {
            width: '100%',
            '& .MuiInputBase-root': {
                borderRadius: 8,
                height: 150,
            }
        }

    }

}));
